var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropdown Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.4165 10.8334L6.07022 12.1408C6.29146 12.5833 6.40208 12.8046 6.54986 12.9963C6.681 13.1664 6.83351 13.3189 7.00363 13.4501C7.19535 13.5978 7.41659 13.7085 7.85907 13.9297L9.1665 14.5834L7.85907 15.2371C7.41659 15.4584 7.19535 15.569 7.00363 15.7168C6.83351 15.8479 6.681 16.0004 6.54986 16.1705C6.40208 16.3623 6.29146 16.5835 6.07022 17.026L5.4165 18.3334L4.76279 17.026C4.54155 16.5835 4.43093 16.3623 4.28315 16.1705C4.15201 16.0004 3.9995 15.8479 3.82938 15.7168C3.63766 15.569 3.41642 15.4584 2.97393 15.2371L1.6665 14.5834L2.97393 13.9297C3.41642 13.7085 3.63766 13.5978 3.82938 13.4501C3.9995 13.3189 4.15201 13.1664 4.28315 12.9963C4.43093 12.8046 4.54155 12.5833 4.76279 12.1408L5.4165 10.8334Z",
    stroke: "#1672BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66675L13.482 4.22043C13.717 4.83146 13.8345 5.13697 14.0173 5.39395C14.1792 5.62171 14.3782 5.8207 14.606 5.98265C14.863 6.16538 15.1685 6.28289 15.7795 6.5179L18.3332 7.50008L15.7795 8.48227C15.1685 8.71728 14.863 8.83478 14.606 9.01751C14.3782 9.17946 14.1792 9.37845 14.0173 9.60621C13.8345 9.8632 13.717 10.1687 13.482 10.7797L12.4998 13.3334L11.5177 10.7797C11.2826 10.1687 11.1651 9.8632 10.9824 9.60621C10.8205 9.37845 10.6215 9.17946 10.3937 9.01751C10.1367 8.83478 9.83121 8.71728 9.22019 8.48227L6.6665 7.50008L9.22019 6.5179C9.83121 6.28289 10.1367 6.16538 10.3937 5.98265C10.6215 5.8207 10.8205 5.62171 10.9824 5.39395C11.1651 5.13697 11.2826 4.83145 11.5177 4.22043L12.4998 1.66675Z",
    stroke: "#1672BA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.3638ace8ae18a1d2b94520f405f61784.svg";
export { ForwardRef as ReactComponent };